import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QrBookletComponent } from './qr-booklet.component';
import { ContentCardModule } from 'src/app/shared/components/content-card/content-card.module';
import { PrimaryButtonModule } from 'src/app/shared/micro-components/primary-button/primary-button.module';
import { InfoCardModule } from 'src/app/components/info-card/info-card.module';
import { SaCardModule } from 'src/app/components/sa-card/sa-card.module';
import { MaterialModule } from 'src/app/core/material/material.module';
import { BaseModule } from 'src/app/core/base/base.module';
import { MatButtonModule } from '@angular/material/button';
import { FabButtonModule } from 'src/app/shared/micro-components/fab-button/fab-button.module';



@NgModule({
  declarations: [
    QrBookletComponent
  ],
  imports: [
    CommonModule,
    BaseModule,
    MaterialModule,
    SaCardModule,
    InfoCardModule,
    ContentCardModule,
    PrimaryButtonModule,
    MatButtonModule,
    FabButtonModule
  ],
  exports: [
    QrBookletComponent
  ]
})
export class QrBookletModule { }
